import React from "react";
import PhoneImage from "../assets/vintage-black-phone.jpg";
import instagram from "../assets/instagram.png";
import linkedin from "../assets/linkedin.png";
import twitter from "../assets/twitter.png";
import github from "../assets/github.png";
import email from "../assets/email.png";

function ContactMe() {
    return (
        <div align="center" className="contact-me">
            <div className="grid-container">
                <div className="grid-item">
                    <img src={PhoneImage} alt="PhoneImage" className="contact-me-image" />
                </div>
                <div className="grid-item">
                    <div className="contact-page">
                        <h1 className="contact-me-heading">Contact Me</h1>
                        <p className="contact-me-paragraph">
                            I'm currently looking for new opportunities. My inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!
                        </p>
                        <p className="contact-me-icons">
                            <a href="https://github.com/emmakamau">
                                <img src={github} alt="github" className="icons" />
                            </a>
                            <a href="mailto:emmaculatewkamau@gmail.com">
                                <img src={email} alt="email" className="icons" />
                            </a>
                            <a href="https://www.linkedin.com/in/emma-k-987353104/">
                                <img src={linkedin} alt="linkedin" className="icons" />
                            </a>
                            <a href="https://twitter.com/emzkamau">
                                <img src={twitter} alt="twitter" className="icons" />
                            </a>
                            <a href="https://www.instagram.com/emmakamau/">
                                <img src={instagram} alt="instagram" className="icons" />
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactMe;